import { render } from "./sectionj&k.vue?vue&type=template&id=d4870af4"
import script from "./sectionj&k.vue?vue&type=script&lang=js"
export * from "./sectionj&k.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__